
export const SALON_AVAILABILITY_DETAIL = "SALON_AVAILABILITY_DETAIL"
export const SALON_AVAILABILITY_UPDATE = "SALON_AVAILABILITY_UPDATE"
export const SALON_AVAILABILITY_STAFF_UPDATE = "SALON_AVAILABILITY_STAFF_UPDATE"
export const BLOCK_SERVICE_REASON = "BLOCK_SERVICE_REASON"
export const BLOCK_SERVICE = "BLOCK_SERVICE"
